<template>
	<sideNav :page-title="pageTitle"></sideNav>
	<div class="ld-panel-title">
		<router-link to="/account/index" class="back-btn"><span></span>密保设置</router-link>
	</div>
	<div class="ld-panel-main">
		<div v-if="!checkToken"><code-verification :secver-type="secverType" @tokenChange="getToken" /></div>
		<el-form v-else :rules="rules" ref="ruleFormRef" inline-message :model="groupForm" :label-width="formLabelWidth">
			<el-form-item label="会员ID">
				<el-input v-model="userid" disabled />
			</el-form-item>
			<el-form-item label="密保问题" prop="question">
				<el-select v-model="groupForm.question" placeholder="请选择密保问题">
					<el-option v-for="item in questionOptions" :key="item.key" :value="item.key" :label="item.value"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="密保答案" prop="answer">
				<el-input v-model="groupForm.answer" autocomplete="off" />
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="submitForm(ruleFormRef)">提交</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script setup>
	import { ref,reactive,onMounted} from 'vue';
	import { useRouter } from 'vue-router';
	import Cookies from 'js-cookie';
	import { getconstinfo,securitysetting } from '@/api/account';
	import sideNav from '../../components/sideNav.vue';
	import codeVerification from '../../components/codeVerification.vue';
	import { ElMessage, ElMessageBox } from 'element-plus';
	
	const router = useRouter();
	const pageTitle = 'account';
	const checkToken = ref(false);
	const authWay = ref('');
	const secverType = 'changequestion';
	const userid = Cookies.get('LDUSERNAME');
	const formLabelWidth = ref('160px');
	const questionOptions = ref();
	const ruleFormRef = ref(null);
	const groupForm = ref({question:'',answer:''});
	const rules = reactive({
		question: [
			{ required: true, message: '请选择密保问题', trigger: 'blur' }
		],
		answer: [
			{ required: true, message: '请填写密保答案', trigger: 'blur' }
		]
	});
	
	
	const getToken = (token,way) =>{
		checkToken.value = token;
		authWay.value = way;
	};
	const fetQusF = () => {
		const param = 'question';
		getconstinfo(param).then((res) => {
			questionOptions.value = res.data.map(item => ({ key: item, value: item }));
		})
	};
	const submitForm = () => {
		if (!ruleFormRef.value) return;
		ruleFormRef.value.validate((valid) => {
			if (valid) {
				const param = groupForm.value;
				param['way'] = authWay.value;
				securitysetting(param).then((res) => {
					if(res.code === 200){
						ElMessage({
							offset:70,
							message: res.msg,
							type: 'success'
						})
						router.back();
					}
				})
			} else {
			  return false;
			}
		});
	};
	
	onMounted(() => {
		fetQusF()
	})
	
</script>

<style>
</style>